module.exports = __webpack_public_path__ + "static/media/1021090.bd843fe7.png";